export var triggerRb = function triggerRb(options) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (debug) {
    window.console.info("RB: ".concat(options.id || options.src, " ").concat(options.type || 'SHOW'));
    return;
  }

  new Image().src = options.src ? options.src : "//rs.mail.ru/".concat(options.type === 'click' ? 'sb' : 'd').concat(options.id, ".gif?r=").concat(Math.round(Math.random() * 10e10));
};